const specs = [
  {
    key: 'not_started',
    desc: 'Program did not start',
    db: 'notStarted',
  },
  {
    key: 'low_access',
    desc: 'Low-level access to the HDD',
    db: 'lowAccess',
  },
  {
    key: 'autostart',
    desc: 'Process was added to the startup',
    db: 'autoStart',
  },
  {
    key: 'debug_output',
    desc: 'Debug information is available',
    db: 'debugOutput',
  },
  {
    key: 'tor',
    desc: 'Probably Tor was used',
    db: 'torUsed',
  },
  {
    key: 'spam',
    desc: 'Behavior similar to spam',
    db: 'spam',
  },
  {
    key: 'injects',
    desc: 'Task has injected processes',
    db: 'injects',
  },
  {
    key: 'executable_dropped',
    desc: 'Executable file was dropped',
    db: 'executableDropped',
  },
  {
    key: 'known_threat',
    desc: 'Known threat',
    db: 'knownThreat',
  },
  {
    key: 'mem_overrun',
    desc: 'RAM overrun',
    db: 'memOverrun',
  },
  {
    key: 'network_threats',
    desc: 'Network attacks were detected',
    db: 'networkThreats',
  },
  {
    key: 'uac_request',
    desc: 'Integrity level elevation',
    db: 'privEscalation',
  },
  {
    key: 'network',
    desc: 'Connects to the network',
    db: 'network',
  },
  {
    key: 'cpu_overrun',
    desc: 'CPU overrun',
    db: 'cpuOverrun',
  },
  {
    key: 'service_luncher',
    desc: 'Process starts the services',
    db: 'serviceLauncher',
  },
  {
    key: 'reboot',
    desc: 'System was rebooted',
    db: 'rebooted',
  },
  {
    key: 'multiprocessing',
    desc: 'Task contains several apps running',
    db: 'multiprocessing',
  },
  {
    key: 'network_loader',
    desc: 'Application downloaded the executable file',
    db: 'networkLoader',
  },
  {
    key: 'stealing',
    desc: 'Actions similar to stealing personal data',
    db: 'stealing',
  },
  {
    key: 'crashed_apps',
    desc: 'Task has apps ended with an error',
    db: 'crashedApps',
  },
  {
    key: 'static_detections',
    desc: 'File is detected by antivirus software',
    db: 'staticDetections',
  },
  {
    key: 'susp_struct',
    desc: 'Inspected object has suspicious PE structure',
    db: 'suspStruct',
  },
  {
    key: 'exploitable',
    desc: 'Behavior similar to exploiting the vulnerability',
    db: 'exploitable',
  },
  {
    key: 'crashed_task',
    desc: 'Task contains an error or was rebooted',
    db: 'crashedTask',
  },
  {
    key: 'malware_config',
    desc: 'The process has the malware config',
    db: 'malwareConfig',
  },
];

export default specs;
